import { Input, Modal } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'

type CreateGroupModalProps = {
  isOpen: boolean
  onClose: () => void
  onCreateGroup: (title: string) => Promise<void>
  isCreating: boolean
}

export const CreateGroupModal: FC<CreateGroupModalProps> = ({
  isOpen,
  onClose,
  onCreateGroup,
  isCreating,
}) => {
  const [title, setTitle] = useState('')

  const handleCreate = async () => {
    if (!title.trim()) return
    await onCreateGroup(title.trim())
    setTitle('')
  }

  const handleCancel = () => {
    setTitle('')
    onClose()
  }

  return (
    <Modal
      title='Create New Group'
      open={isOpen}
      onCancel={handleCancel}
      onOk={handleCreate}
      okText='Create'
      cancelText='Cancel'
      confirmLoading={isCreating}
      okButtonProps={{ disabled: !title.trim() }}>
      <FormContainer>
        <Label>Group Name</Label>
        <Input
          placeholder='Enter group name'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onPressEnter={handleCreate}
          autoFocus
        />
      </FormContainer>
    </Modal>
  )
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 0;
`

const Label = styled.label`
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.activeText};
`
